import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { invalidateMe } from "../lib/useMe";
import { useT } from "../lib/i18n";

type Status = "pending" | "success" | "failure";

export function VerifyEmail() {
  const t = useT();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState<Status>("pending");
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    if (!token) {
      setStatus("failure");
      return;
    }
    api.verifyEmail(token)
      .then(() => { invalidateMe(); setStatus("success"); })
      .catch(() => setStatus("failure"));
  }, [token]);

  return (
    <main className="page-scroll min-h-screen-d flex flex-col items-center justify-center px-6 bg-canvas">
      <div className="w-full max-w-xs flex flex-col items-center animate-rise text-center">
        {status === "pending" && <p className="text-sm text-fg-secondary">{t("common.loading")}</p>}

        {status === "success" && (
          <>
            <p className="text-sm text-fg-secondary mb-6">{t("auth.verified")}</p>
            <Link to="/" className="underline text-sm">
              {t("common.close")}
            </Link>
          </>
        )}

        {status === "failure" && (
          <>
            <p className="text-sm text-fg-secondary mb-6">{t("auth.verifyInvalid")}</p>
            <Link to="/" className="underline text-sm">
              {t("common.close")}
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
